import * as React from 'react';

const { useEffect, useState } = React;

interface Props {
  active: boolean;
  verb: string;
}

export default function LoadingOverlay({ active, verb }: Props) {
  const [start, setStart] = useState<number | null>(null);
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    if (!active) { setStart(null); setElapsed(0); return; }
    const t0 = performance.now();
    setStart(t0);
    const id = setInterval(() => setElapsed((performance.now() - t0) / 1000), 100);
    return () => clearInterval(id);
  }, [active]);

  if (!active) return null;
  return (
    <div className="loading-overlay">
      <div className="spinner" />
      <div className="loading-text">
        {verb}{start != null ? ` ${elapsed.toFixed(1)}s` : ''}
      </div>
    </div>
  );
}

